
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/parking/booking/new/extras",
      function () {
        return require("private-next-pages/[locale]/parking/booking/new/extras.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/parking/booking/new/extras"])
      });
    }
  